import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getSuspensionParts } from '../thunks/partsThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearPartsKey } from '../thunkKeys/partsThunksKeys';

const SLICE_NAME = 'suspensionParts';

export const suspensionPartsSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearSuspensionParts(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getSuspensionParts });
        builder.addCase(clearPartsKey, () => commonInitialState);
    },
});

export const { clearSuspensionParts } = suspensionPartsSlice.actions;

export const suspensionParts = suspensionPartsSlice.reducer;
